module.exports = __webpack_public_path__ + "img/active-mobile-users.86bf82b5.svg";